import { render, staticRenderFns } from "./SetAccount.vue?vue&type=template&id=59ffe11b&scoped=true"
import script from "./SetAccount.vue?vue&type=script&lang=js"
export * from "./SetAccount.vue?vue&type=script&lang=js"
import style0 from "./SetAccount.vue?vue&type=style&index=0&id=59ffe11b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffe11b",
  null
  
)

export default component.exports